import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
   step:{
       personalInfo:{
           requiredField: string;
       };
       docUpload:{
           getHelpLink: string;
       };
   };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            title: 'Unlock this student-only offer',
            subtitle: 'Verify you\'re a student at an eligible institution.',
            requiredField: '* indicates a required field',
        },
        success: {
            subtitle: 'You can redeem your 6 months free LinkedIn Premium now. This code is exclusive and non-transferrable for single use.',
            emailNotification: 'You should receive an email with a copy of your URL to use it now or later. Look for any email from verify@sheerid.com. Your URL is one-time use only.',
            redirectButtonText: 'Redeem now',
            verificationOnly: 'SheerID handles verification only. Please see <a href=https://www.linkedin.com/help/linkedin/answer/a737731 class="sid-link" target="_blank">LinkedIn FAQs</a> in case you have any questions about this offer and the terms and conditions.',
        },
        docUpload: {
            getHelpLink: 'I need help',
        },
        pending: {
            subtitleAlt: 'Turnaround time for your language is typically a few minutes, and in rare times of high volume may take up to 2 hours',
        },
        error: {
            errorId: {
                noRemainingRewardCodes: {
                    title: 'Sorry, this offer is no longer available.',
                },
            },
        },
    },
    getHelp: 'I need help',
    verifyMyStudentStatus: 'Verify my student status',
    errorId: {
        underagePerson: 'Persons under age 18 are not eligible for this offer.',
        noRemainingRewardCodes: ' ',
    },
};
